module.exports = "/images/gotham-19.jpg";